import { useEffect, useState } from 'react';
import { Content } from './Content/Content';
import styles from './CredentialsModal.module.scss';
import { BlockWrapperWithSpinner, Button, ErrorModalContent, Icon, Modal, Spinner, Text } from 'components';
import { Credentials } from 'services/userService';
import { usersActions } from 'store/users/slice';
import { useDispatch } from 'store/utils';

type Props = {
  onClose(): void;
  userId: string;
};

export const CredentialsModal = ({ onClose, userId }: Props) => {
  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState<Credentials>({
    clientId: '',
    clientSecret: '',
  });

  const [isLoading, setIsLoading] = useState(true);

  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const getUserCredentials = async () => {
      try {
        setIsLoading(true);
        const data = await dispatch(usersActions.getCredentials(userId)).unwrap();
        setCredentials(data);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        setIsError(true);
      }
    };

    getUserCredentials();
  }, [userId, dispatch]);

  const generateNewCredentials = async () => {
    try {
      setIsLoading(true);
      const data = await dispatch(usersActions.updateCredentials(userId)).unwrap();
      setCredentials(data);
      setIsLoading(false);
    } catch (err) {
      setIsError(true);
      setIsLoading(false);
    }
  };

  const content = isError ? (
    <ErrorModalContent onConfirm={onClose} title="Error" subtitle="Something went wrong" />
  ) : isLoading ? (
    <BlockWrapperWithSpinner isLoading />
  ) : (
    <Content credentials={credentials} generateCredentials={generateNewCredentials} />
  );

  return (
    <Modal title="Get credentials" onClose={onClose}>
      <div className={styles.container}>{content}</div>
    </Modal>
  );
};
